/*------------------------------------*\
    measurements
\*------------------------------------*/
module.exports = function(){


    //
    //




    $(document).on('input', '[js-include-monogram-input]',function(event) {
        if ( $(this).val()=='on' ) {
            $('[js-white-monogram-input]').prop('checked', true);
        }
    });



    $(document).on('input', '[js-no-monogram-input]',function(event) {
        if ( $(this).val()=='on') {
            $('[js-white-monogram-input]').prop('checked', false);
        }
    });






    var monogramFieldsWrapperHandle = function(){
        var noMonogramInput = $('[js-step-monogram]').find('[js-no-monogram-input]');
        var includeMonogramInput = $('[js-step-monogram]').find('[js-include-monogram-input]');

        if (includeMonogramInput.is(':checked')) {
            $('[js-monogram-enabled-wrapper]').addClass('is-visible');
        }

        if (noMonogramInput.is(':checked')) {
            $('[js-monogram-enabled-wrapper]').removeClass('is-visible');
        }
    };




    var noMonogramClick = function(){
        var includeMonogramInput = $('[js-step-monogram]').find('[js-include-monogram-input]');
        includeMonogramInput.prop('checked', false);
        monogramFieldsWrapperHandle();
    };




    var includeMonogramClick = function(){
        var noMonogramInput = $('[js-step-monogram]').find('[js-no-monogram-input]');
        noMonogramInput.prop('checked', false);
        monogramFieldsWrapperHandle();
    };




    $('[js-no-monogram-input]').on('click', function(event) {
        noMonogramClick();
    });

    $('[js-include-monogram-input]').on('click', function(event) {
        includeMonogramClick();
    });



}; // end of module.exports



// WEBPACK FOOTER //
// ./js-source/integration/monograms.js